import Vue from "vue";
import Router from "vue-router";

// import OwnerRecord from 'pages/ownerRecord/ownerRecord';

// 登录
import Login from "pages/login/index";
import ForgetPassword from "pages/login/forgetPassword";
// 货款
import GoodsPayment from "pages/goodsPayment/index";
import GoodsPaymentDetail from "pages/goodsPayment/detail";
// 提现
import Withdrawal from "pages/withdrawal/withdrawal";
import WithdrawalDetail from "pages/withdrawal/withdrawalDetail";
import WithdrawalForgetPassword from "pages/withdrawal/forgetPassword";
// 详情
// 完成金额
import completerecords from "pages/completeRecords/completerecords";
// 订单
import order from "pages/completeRecords/order";
import sunRefund from "pages/completeRecords/details/sunRefund";
// 公共详情页面
import publicNote from 'pages/public/publicNote';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/login/forget_password",
      component: ForgetPassword
    },
    {
      path: "/order",
      component: order
    },
    {
      path: "/goods_payment",
      component: GoodsPayment
    },
    {
      path: "/goods_payment/goods_payment_detail",
      component: GoodsPaymentDetail
    },
    {
      path: "/withdrawal",
      component: Withdrawal
    },
    {
      path: "/withdrawal/withdrawal_detail",
      component: WithdrawalDetail
    },
    {
      path: "/withdrawal/forget_password",
      component: WithdrawalForgetPassword
    },
    {
      path: "/complete/records",
      component: completerecords
    },
    {
      path: "/sunRefund",
      component: sunRefund
    },
    {
      path: "/publicNote",
      component: publicNote
    },
    {
      path: "*",
      redirect: "/login"
    }
  ],
  mode: "history",
  // mode: 'hash',
  scrollBehavior(to, from, savedPosition) {
    // vue滚动行为
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js